import Vue from "vue";
import { Component, PropSync } from "vue-property-decorator";
import VehicleRestModel from "../../../models/rest/vehicle/vehicleRestModel";

@Component
export default class AdrTailLiftDialog extends Vue {
    @PropSync("show", { type: Boolean, default: false })
    showDialog!: boolean;

    validation = {
        isADR: [(value: boolean | null) => value !== null && value !== undefined || this.$t("common.validationErrorRequired")],
        tailLift: [(value: boolean | null) => value !== null && value !== undefined || this.$t("common.validationErrorRequired")],
    }

    get boolItems() {
        return [
            { text: this.$t("common.yes"), value: true },
            { text: this.$t("common.no"), value: false },
        ];
    }

    get vehicle(): VehicleRestModel {
        return this.$store.direct.state.vehicle.vehicle;
    }

    set vehicle(val: VehicleRestModel) {
        this.vehicle = val;
    }

    async saveClick() {
        const valid = (this.$refs.form as Vue & { validate: () => boolean }).validate();
        if (valid) {
            try {
                await this.$store.direct.dispatch.vehicle.saveVehicle();
                this.showDialog = false;
            } catch (err) {
                console.error('Error saving vehicle ADR/TailLift:', err);
            }
        }
    }

    cancelClick() {
        this.showDialog = false;
    }
}
